module.exports = __webpack_public_path__ + "static/media/M010.af8724d5.svg";